module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M37.9,36.06c-6.08,0-11.03,4.95-11.03,11.03s4.95,11.03,11.03,11.03,11.03-4.95,11.03-11.03-4.95-11.03-11.03-11.03Zm0,1.84c5.07,0,9.19,4.12,9.19,9.19,0,1.95-.61,3.75-1.65,5.24-1.12-1.26-2.53-2.21-4.09-2.78,1.26-1.01,2.06-2.56,2.06-4.3,0-3.04-2.47-5.52-5.52-5.52s-5.52,2.47-5.52,5.52c0,1.74,.81,3.28,2.06,4.3-1.56,.57-2.97,1.52-4.09,2.78-1.04-1.49-1.65-3.29-1.65-5.24,0-5.07,4.12-9.19,9.19-9.19Zm-3.68,7.35c0-2.03,1.65-3.68,3.68-3.68s3.68,1.65,3.68,3.68-1.65,3.68-3.68,3.68-3.68-1.65-3.68-3.68Zm-2.65,8.49c1.56-1.87,3.87-2.98,6.32-2.98s4.76,1.11,6.32,2.98c-1.65,1.57-3.87,2.54-6.32,2.54s-4.67-.97-6.32-2.54Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M66.4,25.03V14H27.79v14.71c-2.53,0-4.6,2.06-4.6,4.6v13.79c0,2.54,.65,4.94,1.79,7.02l-9.76,9.76c-.79,.79-1.22,1.83-1.22,2.95,0,2.3,1.87,4.17,4.17,4.17,1.11,0,2.16-.43,2.95-1.22l9.76-9.76c2.09,1.14,4.48,1.79,7.02,1.79h28.5c2.53,0,4.6-2.06,4.6-4.6V29.63c0-2.53-2.06-4.6-4.6-4.6ZM29.63,15.84h34.94v9.19h-4.91c-1.23,0-2.38,.48-3.25,1.35l-2.33,2.33H29.63V15.84Zm-1.84,14.71h27.04l2.87-2.87c.52-.52,1.21-.81,1.95-.81h6.75c1.52,0,2.76,1.24,2.76,2.76v2.76H25.2c.38-1.07,1.39-1.84,2.59-1.84Zm-2.76,3.68h5.77c-2.42,1.34-4.42,3.34-5.77,5.77v-5.77Zm-5.21,34.25c-.44,.44-1.03,.68-1.65,.68-1.28,0-2.33-1.05-2.33-2.33,0-.62,.24-1.21,.68-1.65l9.48-9.48c.92,1.27,2.03,2.38,3.3,3.3l-9.48,9.48Zm5.21-21.38c0-7.1,5.77-12.87,12.87-12.87s12.87,5.77,12.87,12.87-5.77,12.87-12.87,12.87-12.87-5.77-12.87-12.87Zm41.37,12.87h-21.39c4.53-2.51,7.6-7.34,7.6-12.87s-3.08-10.36-7.6-12.87h24.15v22.98c0,1.52-1.24,2.76-2.76,2.76Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M65.48,52.61h-7.35c-1.01,0-1.84,.82-1.84,1.84v1.84c0,1.01,.82,1.84,1.84,1.84h7.35c1.01,0,1.84-.82,1.84-1.84v-1.84c0-1.01-.82-1.84-1.84-1.84Zm0,3.68h-7.35v-1.84s0,0,0,0h7.35v1.84Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M31.47,26.87h16.55v-9.19H31.47v9.19Zm1.84-7.35h12.87v5.52h-12.87v-5.52Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M49.85,17.68h12.87v1.84h-12.87v-1.84Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2ef0cd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/vakansiy.vue
// module id = 59cc7db364d63c55adf9
// module chunks = 89